import fields from '../../db/main-fields'
import { mapState } from 'vuex'
import {guid} from "../../util/helpers";

export default {
  data () {
    return {}
  },

  computed: {
    ...mapState(['basic']),
    mainFields () {
      return this.basic.fields
    }
  },
  methods: {
  }
}
